"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apollo_client_1 = __importDefault(require("apollo-client"));
var apollo_link_http_1 = require("apollo-link-http");
var apollo_cache_inmemory_1 = require("apollo-cache-inmemory");
var apollo_link_context_1 = require("apollo-link-context");
var graphql_1 = require("graphql");
var graphql_tools_1 = require("graphql-tools");
var apollo_link_schema_1 = require("apollo-link-schema");
var unfetch_1 = __importDefault(require("unfetch"));
var introspectionSchema_json_1 = __importDefault(require("./introspectionSchema.json"));
var authApi_1 = __importDefault(require("../../platfrom/api/authApi"));
var mocks_1 = __importDefault(require("./mocks"));
var schemaSDL = (0, graphql_1.printSchema)((0, graphql_1.buildClientSchema)(introspectionSchema_json_1.default.data));
var getClient = function (token) {
    var isMockMode = process.env.CB_MODE === 'mock';
    var executableSchema = (0, graphql_tools_1.makeExecutableSchema)({ typeDefs: schemaSDL });
    var httpLink = new apollo_link_http_1.HttpLink({
        uri: "".concat(process.env.CB_CONTENT_SERVICE_SERVER_URL, "/graphql"),
        fetch: unfetch_1.default,
    });
    var authLink = (0, apollo_link_context_1.setContext)(function (_, _a) {
        var headers = _a.headers;
        return __awaiter(void 0, void 0, void 0, function () {
            var user;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!!token) return [3 /*break*/, 2];
                        return [4 /*yield*/, (0, authApi_1.default)()];
                    case 1:
                        user = _b.sent();
                        _b.label = 2;
                    case 2: return [2 /*return*/, {
                            headers: {
                                Authorization: token || user.token,
                            },
                        }];
                }
            });
        });
    });
    (0, graphql_tools_1.addMockFunctionsToSchema)({
        schema: executableSchema,
        mocks: mocks_1.default,
        preserveResolvers: true, // This needs to be true to get __resolveType to trigger
    });
    var mockSchemaLink = new apollo_link_schema_1.SchemaLink({ schema: executableSchema });
    var defaultOptions = {
        watchQuery: {
            fetchPolicy: 'network-only',
            errorPolicy: 'ignore',
        },
        query: {
            fetchPolicy: 'no-cache',
            errorPolicy: 'all',
        },
    };
    return new apollo_client_1.default({
        cache: new apollo_cache_inmemory_1.InMemoryCache(),
        link: isMockMode ? mockSchemaLink : authLink.concat(httpLink),
        defaultOptions: defaultOptions,
    });
};
exports.default = getClient;
